import { notify } from 'react-notify-toast'

const WRAPPER_ID = 'notification-wrapper'
const MAX_ATTEMPTS = 60

/*
 * react-notify-toast requires #notification-wrapper from ToastNotifications.
 * After Turbo Drive navigations that remount React, wait until the host exists.
 */
export const showToast = (text, type, attempt = 0) => {
  const wrapper = document.getElementById(WRAPPER_ID)

  if (wrapper) {
    notify.show(text, type)
    return
  }

  if (attempt < MAX_ATTEMPTS) {
    requestAnimationFrame(() => showToast(text, type, attempt + 1))
  }
}
